import { $http } from '@/utils';

/**
 * @namespace Service
 * @class Complete
 * @exports Service/Complete
 * @description API Complete Service
 * @date 2021/04/01
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class Complete {
	/**
	 * @static @name get
	 * @description Performs API verify
	 * @returns {Object} Promise a http response
	 */
	static get(token) {
		return $http.get(`account/registration/complete/${token}`);
	}

	/**
	 * @static @name post
	 * @description Performs API verify
	 * @returns {Object} Promise a http response
	 */
	static post(token, payload) {
		return $http.post(`account/registration/complete/${token}`, payload);
	}
}
